import axios from 'axios'
import Vue from 'vue'
import qs from 'qs';
let url = { BASE_URL: 'https://www.cstr.cn/openapi/v3/' }
// let url = { BASE_URL: 'http://localhost:8000/', }
// 环境的切换
if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseURL = url.BASE_URL;
} else if (process.env.NODE_ENV == 'debug') {
    axios.defaults.baseURL = url.BASE_URL
} else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = url.BASE_URL
}
var that = this
// 请求拦截器
axios.interceptors.request.use(req => {
    if (Vue.prototype.$cookie.get('token')) {
        var token = Vue.prototype.$cookie.get('token')
        req.headers.Authorization = token
    }
    if (Vue.prototype.$cookie.get('username')) {
        var username = Vue.prototype.$cookie.get('username')
        req.headers.userName = username
    }
    return req;
}, error => {
    return Promise.reject(error);
})

axios.interceptors.response.use(res => {

    return res
}, error => {

    return Promise.reject('数据返回失败', error)
})


export default axios;